export default __webpack_public_path__ + "static/media/hostfully_step13.5e9c1770.png";